import axios from 'axios';
import { getV7MicroServiceUrl } from '../helpers/helpers';

export const getPropertyDetails = (id) => ({
  type: 'GET_PROPERTY_DETAILS',
  payload: axios.get(
    `${getV7MicroServiceUrl('business-user')}property_detail/${id}`,
  ),
});
